function FAQ({ items = [], title = 'Frequently asked questions', eyebrow }) {
    if (!items.length) return null

    return (
        <div className="faq-accordion">
            {eyebrow && (
                <span className="mono-label" style={{ display: 'block', textAlign: 'center' }}>
                    {eyebrow}
                </span>
            )}
            <h2 className="faq-accordion__title">{title}</h2>
            <div className="faq-accordion__list">
                {items.map((item) => (
                    <details key={item.id} className="faq-accordion__item">
                        <summary className="faq-accordion__question">{item.question}</summary>
                        <div className="faq-accordion__answer">
                            <p>{item.answer}</p>
                        </div>
                    </details>
                ))}
            </div>
        </div>
    )
}

export default FAQ
